// Copyright (c) 2025 Ipivot Corporation.
'use strict';

import Table from 'react-bootstrap/Table';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, LinearScale } from 'chart.js';
import { FingerprintStatCategory } from '../data';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function CatStats({ data }) {
    if (!data) {
        return <div>Loading...</div>;
    }
    let udata = data.bycategory;
    let disp = [] as FingerprintStatCategory[];
    let leftover = 0;
    for (let i = 0; i < udata.length; i++) {
        if (udata[i].category === 'ALL') {
            continue;
        }
        if (disp.length > 9) {
            leftover += udata[i].count;
        } else {
            disp.push(udata[i]);
        }
    }
    disp.push({ category: 'Other', count: leftover });
    const cdata = {
        labels: disp.map((item: FingerprintStatCategory) => item.category),
        datasets: [{
            label: 'Fingerprints',
            data: disp.map((item: FingerprintStatCategory) => item.count),
            backgroundColor: [
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
              ],
              borderColor: [
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
              ],
              borderWidth: 1,
        }],
    }
    return (
        <Container fluid>
            <Row>
                <Col className="col-6">
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Category</th>
                                <th>Fingerprints</th>
                            </tr>
                        </thead>
                        <tbody>
                            {udata.map((x, index) => (
                                <tr key={index}>
                                    <td>{x.category}</td>
                                    <td>{x.count}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
                <Col className="col-6">
                    <Pie data={cdata} options={{
                        plugins: {
                            legend: {
                                display: true
                            },
                        }
                    }}/>
                </Col>
            </Row>
        </Container>
    );
}
export default CatStats;